module.exports = __webpack_public_path__ + "static/media/asisa.c6ce4900.png";